var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagneto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magento-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#f77c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#f77c7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "magento",
    transform: "translate(264.465 -329.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M-237.018,381.127l-9.739-6.117a.7.7,0,0,1-.343-.612v-9.421l8.271-5.016a.708.708,0,0,1,.759,0l7.708,4.625a.73.73,0,0,1,.367.636v11.5a.7.7,0,0,1-.343.612l-5.9,3.793A.751.751,0,0,1-237.018,381.127Z",
    transform: "translate(0 -9.894)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(-247.1 346.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M-246.513,364.748h0a.6.6,0,0,1-.587-.587V353.418a.769.769,0,0,1,.343-.636l9.764-5.922a.708.708,0,0,1,.759,0l9.763,5.922a.71.71,0,0,1,.343.636V364.16a.6.6,0,0,1-.587.587h0a.6.6,0,0,1-.587-.587V354.079a.769.769,0,0,0-.343-.636l-8.589-5.212a.708.708,0,0,0-.759,0l-8.589,5.212a.709.709,0,0,0-.343.636V364.16A.6.6,0,0,1-246.513,364.748Z",
    transform: "translate(247.1 -346.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(-240.909 356.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M-217.909,401.86l-3.548-2.2a.7.7,0,0,1-.343-.612V387.887a.6.6,0,0,1,.587-.587h0a.6.6,0,0,1,.587.587v10.522a.761.761,0,0,0,.367.636l2.374,1.395a.708.708,0,0,0,.759,0l2.4-1.493a.7.7,0,0,0,.343-.612l.024-10.449a.6.6,0,0,1,.587-.587h0a.6.6,0,0,1,.587.587v11.158a.7.7,0,0,1-.343.612l-3.573,2.227A.742.742,0,0,1-217.909,401.86Z",
    transform: "translate(221.8 -387.3)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagneto);
export default __webpack_public_path__ + "static/media/magneto.a1b5d32d4f2d21f5c04f59c0ee817df4.svg";
export { ForwardRef as ReactComponent };